import { useState } from 'react';
import usePageMeta from '../components/usePageMeta';
import { FORMSPREE_ENDPOINT, FORMSPREE_FORM_ID } from '../config';

const initialForm = { name: '', email: '', topic: 'General enquiry', message: '' };

function Contact() {
  usePageMeta(
    'Contact',
    'Get in touch with Australia College about OneSchool Companion, Voceda, or SMS Tutor.'
  );

  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState('idle'); // idle | sending | success | error

  const isConfigured = FORMSPREE_FORM_ID !== 'YOUR_FORMSPREE_FORM_ID';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isConfigured) {
      setStatus('error');
      return;
    }

    setStatus('sending');

    try {
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(e.target),
      });

      if (res.ok) {
        setStatus('success');
        setForm(initialForm);
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <>
      <section className="product-hero">
        <div className="container">
          <span className="eyebrow">Contact</span>
          <h1>Get in touch</h1>
          <p className="product-hero-lead">
            Questions about a product, feedback, or interested in early
            access to something we're building? Send us a message and we'll
            reply as soon as we can.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <form className="form-card" onSubmit={handleSubmit}>
            {status === 'success' && (
              <div className="form-status form-status--success">
                Thanks — your message has been sent. We'll be in touch soon.
              </div>
            )}
            {status === 'error' && (
              <div className="form-status form-status--error">
                {isConfigured
                  ? "Something went wrong sending your message. Please try again shortly."
                  : 'The contact form isn\'t fully set up yet — please check back soon.'}
              </div>
            )}

            <div className="form-row">
              <label htmlFor="name">Name</label>
              <input
                id="name"
                name="name"
                type="text"
                required
                value={form.name}
                onChange={handleChange}
              />
            </div>

            <div className="form-row">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                name="email"
                type="email"
                required
                value={form.email}
                onChange={handleChange}
              />
            </div>

            <div className="form-row">
              <label htmlFor="topic">What's this about?</label>
              <select id="topic" name="topic" value={form.topic} onChange={handleChange}>
                <option>General enquiry</option>
                <option>OneSchool Companion</option>
                <option>Voceda</option>
                <option>SMS Tutor</option>
                <option>Something else</option>
              </select>
            </div>

            <div className="form-row">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                rows="5"
                required
                value={form.message}
                onChange={handleChange}
              />
            </div>

            <button type="submit" className="btn btn-primary" disabled={status === 'sending'}>
              {status === 'sending' ? 'Sending…' : 'Send message'}
            </button>
            <p className="form-note">
              We reply by email and never share your details with third
              parties.
            </p>
          </form>
        </div>
      </section>
    </>
  );
}

export default Contact;
